export enum PayeeStatusEnum {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  ACTION_REQUIRED = 'ACTION_REQUIRED',
}
